import { useContext, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Stack from "react-bootstrap/Stack";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { DoctorService, LoginService, PatientService } from "../../services";
import { LanguageContext } from "../../utils/Language";

export default function PatientMessages(props) {
  const [messages, setMessages] = useState([]);
  const user = LoginService.getUser();
  const { dictionary } = useContext(LanguageContext);

  const getMessages = (patientId, page) => {
    PatientService.getMessages(patientId, page)
      .then((json) => {
        setMessages(json);
        DoctorService.setCommentsReaad(props.patientId)
      })
      .catch((err) => {
        console.log("Unknown error. fetching patient messages", "danger", err);
      });
  };

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // Update the document title using the browser API
    getMessages(props.patientId, 0);
  }, [props.refresh]);

  return (
    <div>
      <h3>{dictionary.MessagesForThisPatient}</h3>
      <Stack gap="1" style={{ overflowY: "auto", height: "50vh" }}>
        {[...messages].reverse().map((item) => {
          const isDoctor = user.UserId == item.UserId;
          const userName = isDoctor ? dictionary.DoctorText : "OrthoMagic";
          return (
            <Card key={item.Id} border={item.RUserId === 0 && !isDoctor? "info" : "light"}>
              <Card.Header>
                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Tooltip className="d-none d-lg-block">
                      {item.SystemDate}
                    </Tooltip>
                  }
                >
                  <Stack direction="horizontal">
                    <div>{userName}</div>
                    <div className="ms-auto text-muted d-none d-lg-block">
                      {item.SystemDate && typeof item.SystemDate === "string" ? item.SystemDate.split(" ")[0] : item.SystemDate || ""}
                    </div>
                    <div className="ms-auto text-muted d-lg-none">
                      {item.SystemDate || ""}
                    </div>
                  </Stack>
                </OverlayTrigger>
              </Card.Header>
              <Card.Body>{item.Note}</Card.Body>
            </Card>
          );
        })}
      </Stack>
    </div>
  );
}
